/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchGetPriorizationData = (type) =>
  apiActionCreator({
    'endpoint': `/vehicles/vehicle-production/${type}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_PRIORIZATION_DATES,
      ActionTypes.FETCHED_GET_PRIORIZATION_DATES,
      [
        ActionTypes.FETCH_GET_PRIORIZATION_DATES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchGetOrdersByDate = (orderType) =>
  apiActionCreator({
    'endpoint': `/vehicles/schedules-orders-by_type/${orderType}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_ORDERS_BY_DATE,
      ActionTypes.FETCHED_GET_ORDERS_BY_DATE,
      [
        ActionTypes.FETCH_GET_ORDERS_BY_DATE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const fetchGetOrdersAmountByDate = (setDates, orderType, date) =>
  apiActionCreator({
    'endpoint': `/vehicles/schedules-orders-by_type_date/${orderType}/${date}`,
    'authenticated': true,
    'types': [
      ActionTypes.PRIORIZATION_DUMMY_ACTION,
      [
        (response) => {
          setDates((dates) => {
            return ({
              ...dates,
              [orderType]: {
                'total': response.data.dailyQuota,
                'partial': response.data.vehicleCapacityOcuped[0].labelsCount,
              },
            });
          });
          return {
            'type': ActionTypes.PRIORIZATION_DUMMY_ACTION,
          };
        },
      ],
      [
        ActionTypes.PRIORIZATION_DUMMY_ACTION,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updateOrdersAmountByDate = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/update-dates-vehicle-production',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATE_ORDERS_AMOUNT_BY_DATE,
      [
        ActionTypes.UPDATED_ORDERS_AMOUNT_BY_DATE,
        MessageActions.addMessageBoxInfo('La acción "Actualizar fechas" se ha ejecutado exitosamente.'),
      ],
      [
        ActionTypes.UDATE_ORDERS_AMOUNT_BY_DATE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });

export const fetchGetFreeDatesLogistic = () =>
  apiActionCreator({
    'endpoint': '/vehicles/calendar-disable-days',
    'authenticated': true,
    'types': [
      ActionTypes.FETCH_FREE_DATES_LOGISTIC,
      ActionTypes.FETCHED_FREE_DATES_LOGISTIC,
      [
        ActionTypes.FETCH_FREE_DATES_LOGISTIC_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const removeVehiclesPriorization = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/update-dates-vehicle-production',
    'authenticated': true,
    'types': [
      ActionTypes.REMOVE_VEHICLES_PRIORIZATION,
      [
        ActionTypes.REMOVED_VEHICLES_PRIORIZATION,
        MessageActions.addMessageBoxInfo('La acción "Remover priorización" se ha ejecutado exitosamente.'),
      ],
      [
        ActionTypes.REMOVE_VEHICLES_PRIORIZATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'data': data,
    'contentType': 'application/json',
  });

export const fetchPriorizationCombos = (dealer, model, sfx) =>
  apiActionCreator({
    'endpoint': `/sets/combo-dealer-model/${dealer}/${sfx}/${model}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PRIORIZATION_COMBOS,
      ActionTypes.FETCHED_PRIORIZATION_COMBOS,
      [
        ActionTypes.FETCH_PRIORIZATION_COMBOS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updateVehicleCombo = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/update-set-vehicle-production',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATE_VEHICLE_COMBO,
      [
        ActionTypes.UPDATED_VEHICLE_COMBO,
        MessageActions.addMessageBoxInfo('La acción "Actualizar combo" se ha ejecutado exitosamente.'),
      ],
      [
        ActionTypes.UPDATE_VEHICLE_COMBO_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });

export const removeDatesPriorization = (typeName, data) =>
  apiActionCreator({
    'endpoint': '/vehicles/delete-dates',
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_DATES_PRIORIZATION,
      [
        ActionTypes.DELETE_DATES_PRIORIZATION,
        MessageActions.addMessageBoxInfo(`La acción "REMOVER FECHA DE ${typeName}" se ha ejecutado exitosamente.`),
      ],
      [
        ActionTypes.DELETE_DATES_PRIORIZATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'data': data,
    'contentType': 'application/json',
  });


export const fetchAddDaysToDateLogistic = (date, days, setDate, name) =>
  apiActionCreator({
    'endpoint': `/calendar-tems/add-days-to-date?date=${date}&days=${days}&area=LOGISTICA`,
    'authenticated': true,
    'types': [
      [ActionTypes.PRIORIZATION_DUMMY_ACTION],
      [
        (response) => {
          setDate(name, response.data);
          return {
            'type': ActionTypes.PRIORIZATION_DUMMY_ACTION,
            'payload': response.data,
          };
        },
      ],
      [ActionTypes.PRIORIZATION_DUMMY_ACTION, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const cleanOrdersBYDate = () => ({
  'type': ActionTypes.CLEAN_ORDERS_BY_DATE,
  'payload': null,
});

export const setSelectedVehicleCombo = (data) => ({
  'type': ActionTypes.SET_SELECTED_VEHICLE_COMBO,
  'payload': data,
});

export const updateVehicleAgency = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/update-agency',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATE_VEHICLE_AGENCY,
      [
        ActionTypes.UPDATED_VEHICLE_AGENCY,
        MessageActions.addMessageBoxInfo('La acción "Actualizar combo" se ha ejecutado exitosamente.'),
      ],
      [
        ActionTypes.UPDATE_VEHICLE_AGENCY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });
  
  
export const setSelectedVehicleAgency = (data) => ({
  'type': ActionTypes.SET_SELECTED_VEHICLE_AGENCY,
  'payload': data,
});

export const fetchSuggestedPriorizationDates = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/dealer-priorization',
    'authenticated': true,
    'types': [
      [ActionTypes.FETCHING_SUGGESTED_PRIORIZATION_DATES],
      [ActionTypes.FETCHED_SUGGESTED_PRIORIZATION_DATES],
      [ActionTypes.FETCHED_SUGGESTED_PRIORIZATION_DATES_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': data,
    'contentType': 'application/json',
  });

export const cleanSuggestedPriorizationDates = () => ({
  'type': ActionTypes.CLEAN_SUGGESTED_PRIORIZATION_DATES,
});

export const savePriorization = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles/dealer-priorization',
    'authenticated': true,
    'types': [
      [ActionTypes.SAVING_PRIORIZATION],
      [
        {'type': ActionTypes.SAVED_PRIORIZATION},
        () => cleanSuggestedPriorizationDates(),
        (response) => buildSuccessMessage(response, 'Priorización realizada con éxito.'),
      ],
      [ActionTypes.SAVED_PRIORIZATION_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });

export const saveLogisticObservation = (data, closeModal) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/vehicles/update-comments-vehicle-production',
    'authenticated': true,
    'types': [
      [ActionTypes.SAVING_LOGISTIC_OBSERVATION],
      [
        {'type': ActionTypes.SAVED_LOGISTIC_OBSERVATION},
        (response) => dispatch(
          buildSuccessMessage(response, 'Observación guardada con éxito.'),
          closeModal(),
        ),
      ],
      [
        ActionTypes.SAVED_LOGISTIC_OBSERVATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};
